import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const QuoteRenewalsPage = lazyLoad(
    () => import('./index'),
    module => module.QuoteRenewalsPage,
    { fallback: <LoadingSpinner /> },
);
